import { render, staticRenderFns } from "./AsignarDocumentos.vue?vue&type=template&id=4de4c51f"
import script from "./AsignarDocumentos.vue?vue&type=script&lang=js"
export * from "./AsignarDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports